
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTargetAssociatedCameraRadar as ObiTargetAssociatedCameraRadarElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-target-associated-camera-radar.js';
 
 
 

 
 export const ObiTargetAssociatedCameraRadar = createComponent({
   react: React,
   tagName: 'obi-target-associated-camera-radar',
   elementClass: ObiTargetAssociatedCameraRadarElement,
   events: {
     
   }
  });
 
 